// Chakra imports
import { Box } from '@chakra-ui/react';
import Footer from '../components/Footer.js';
// Layout components
import Sidebar from '../components/Sidebar';
import React from 'react';
import {
	Outlet,
} from 'react-router-dom';

// Custom Chakra theme

export default function DashboardLayout() {
	// Chakra Color Mode
	return (
		<>
			<Sidebar/>
			<Box
				w={{ base: '100%', xl: 'calc(100% - 275px)' }}
				float={'right'} maxW = "100%" maxH="100%" overflow="auto" pos="relative"
			>
				<Box ms= "auto" me= "auto" ps= "15px" pe= "15px" >
					<Box p= "30px 15px" minHeight="calc(100vh - 123px)" >
						<Outlet />
					</Box>

				</Box>
				<Footer />
			</Box>
		</>
	);
}
